import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
interface IProps {
  name: string
  type?: 'text' | 'number' | 'email' | 'password' | 'tel'
  value?: string | number
  forCounter?: boolean
  defaultValue?: string
  readonly?: boolean
  label?: null | string
  placeholder?: null | string
  error?: null | string
  required?: boolean
  password?: boolean
  pattern?: string
  inputRef?: any
  disabled?: boolean
  onChangeHandler?(event: any): void | Promise<void>
  onBlurHandler?(event: any): void | Promise<void>
}

export const InputTextAlt: React.FC<IProps> = props => {
  const initialValueFromProps = props.defaultValue ?? props.value
  const [localValue, setLocalValue] = React.useState<string | number>(initialValueFromProps ?? '')

  React.useEffect(() => {
    if (props.value !== null && props.value !== undefined) {
      setLocalValue(props.value)
    }
  }, [props.value])

  return (
    <InputTextWrapper className="InputText">
      <div className="InputText_Main">
        <div className="Input_Text_Form">
          <input
            className="Input_Text_Field"
            id={props.name}
            type={props.password ? 'password' : props.type ?? 'text'}
            name={props.name}
            autoComplete="off"
            placeholder=""
            pattern={props.pattern}
            required={props.required ? true : false}
            value={localValue}
            onChange={event => {
              setLocalValue(event.target.value)
              if (typeof props.onChangeHandler === 'function') {
                props.onChangeHandler(event)
              }
            }}
            onBlur={event => {
              setLocalValue(event.target.value)
              if (typeof props.onBlurHandler === 'function') {
                props.onBlurHandler(event)
              }
            }}
            ref={props.inputRef || null}
            readOnly={props.readonly || false}
            disabled={props.disabled || false}
          />
          <label htmlFor="" className="Input_Text_Label">
            <span className="Input_Label_Name">{props.label}</span>
          </label>
        </div>
        {props.error && <span className="InputText_Error">{props.error}</span>}
      </div>
    </InputTextWrapper>
  )
}

const InputTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .InputText_Main {
    width: 100%;
  }
  .Input_Text_Form {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .Input_Text_Field {
    width: 100%;
    padding-top: 40px;
    font-size: 1.6rem;
    background: transparent;
    outline: none;
    z-index: 2;
    border: 1px solid ${constants.COLORS.divider};
    height: 5.6rem;
    padding: 2.4rem 2.4rem 0.8rem;
    border-radius: 1.2rem;
    transition: border-color 0.2s;
    &:focus {
      border-color: ${constants.COLORS.primary};
    }
  }

  .Input_Text_Label {
    position: absolute;
    bottom: 2rem;
    left: 2.4rem;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    z-index: 1;
  }

  .Input_Label_Name {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transform: translateY(3.6rem);
    transition: transform 0.2s ease-in-out, font-size 0.2s ease-in-out;
  }

  .Input_Text_Label::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0%;
  }

  .Input_Text_Field:focus ~ .Input_Text_Label::after,
  .Input_Text_Field:not(:placeholder-shown) ~ .Input_Text_Label::after {
    width: 100%;
    transition: 0.2s;
  }

  .Input_Text_Field:focus ~ .Input_Text_Label .Input_Label_Name,
  .Input_Text_Field:not(:placeholder-shown) ~ .Input_Text_Label .Input_Label_Name {
    font-size: 1.2rem;
    transform: translateY(2.4rem);
  }

  input[readonly] {
    background-color: ${constants.COLORS.divider};
  }

  .InputText_Error {
    display: block;
    margin-top: 0.8rem;
    color: ${constants.COLORS.cautionText};
    font-size: 1.4rem;
  }
`
